import { Flex, Input, Typography } from "antd"
import cls from "classname"
import { useSelector } from "react-redux"

import Images from "../../../../Images"

import "./SourceDetail.less"

const { Text } = Typography

const SelectWithInput = ({ options, value, onChange }) => {
  const { theme } = useSelector((state) => state.nav)
  return (
    <Flex className="select-with-input" gap={8}>
      {options.map((option) => (
        <button
          key={option.value}
          className={cls("select-with-input-option", {
            active: value === option.value
          })}
          onClick={() => onChange(option.value)}
          type="button"
        >
          {option.image && (
            <img
              width={20}
              height={20}
              src={
                Images?.[theme === "dark" && option?.darkImage ? option?.darkImage : option?.image]
              }
              alt=""
            />
          )}
          <span>
            <Text>{option.label}</Text>
            {option?.additionalText && <Text type="secondary">{option.additionalText}</Text>}
          </span>
        </button>
      ))}
      <Input
        placeholder="Other..."
        value={value?.type === "Other" ? value?.value : null}
        onChange={(e) =>
          onChange(
            e.target.value
              ? {
                  value: e.target.value,
                  type: "Other"
                }
              : null
          )
        }
        className="input-without-error"
      />
    </Flex>
  )
}

const socialMediaOptions = [
  {
    label: "Instagram",
    value: "Instagram",
    image: "instagram"
  },
  {
    label: "TikTok",
    value: "TikTok",
    image: "tiktok"
  },
  {
    label: "Youtube",
    value: "YouTube",
    image: "youtube"
  },
  {
    label: "X",
    value: "X",
    image: "x",
    darkImage: "x_dark",
    additionalText: " (ex. Twitter)"
  },
  {
    label: "Linkedin",
    value: "LinkedIn",
    image: "linkedin"
  },
  {
    label: "Facebook",
    value: "Facebook",
    image: "facebook"
  }
]

const aiOptions = [
  {
    label: "ChatGPT",
    value: "ChatGPT",
    image: "chatgpt",
    darkImage: "chatgpt_dark"
  },
  {
    label: "Grok",
    value: "Grok",
    image: "grok",
    darkImage: "grok_dark",
    additionalText: " (xAI)"
  },
  {
    label: "Llama",
    value: "Llama",
    image: "meta"
  },
  {
    label: "Claude",
    value: "Claude",
    image: "claude"
  },
  {
    label: "Perplexity",
    value: "Perplexity",
    image: "perplexity"
  },
  {
    label: "Gemini",
    value: "Gemini",
    image: "gemini"
  }
]

export const sourceDetailComponentMap = {
  social_media: <SelectWithInput options={socialMediaOptions} />,
  app_marketplace: null,
  ai_tools: <SelectWithInput options={aiOptions} />,
  search_engine: null,
  through_friend: null,
  email_newsletter: null,
  partner_program: (
    <Input
      placeholder="Tell us which course or community helped you to find us..."
      className="input-without-error"
    />
  ),
  events: (
    <Input
      placeholder="Tell us which event or award helped you to find us..."
      className="input-without-error"
    />
  ),
  industry_recommendation: (
    <Input
      placeholder="Tell us which industry recommendation helped you to find us..."
      className="input-without-error"
    />
  ),
  other: (
    <Input
      placeholder="Tell us what other source helped you to find us..."
      className="input-without-error"
    />
  )
}
